import React, { useMemo } from 'react';
import CustomCard from '../../../components/@extended/CustomCard';
import { Box, CardContent, Divider, dividerClasses, Typography } from '@mui/material';
import { Pie } from 'react-chartjs-2';
import { useParams } from 'react-router-dom';
import { getSiteBudgetAndExpenditure } from './siteDashboardUtils';

const FinanceSiteBudgetPie = ({ dashboardData }) => {
  const { trialSiteId } = useParams();

  const { totalBudget, totalExpenditure } = useMemo(
    () => getSiteBudgetAndExpenditure(dashboardData, trialSiteId),
    [dashboardData, trialSiteId]
  );

  const data = useMemo(() => {
    return {
      chartData: {
        labels: ['Total Budget', 'Total Expenditure'],
        datasets: [
          {
            label: 'Cost',
            data: [totalBudget, totalExpenditure],
            backgroundColor: ['#A5D027', '#004078'],
            borderColor: ['#A5D027', '#004078'],
            borderWidth: 1,
          },
        ],
      },
      totalCost: totalExpenditure + totalBudget,
    };
  }, [totalExpenditure, totalBudget]);
  return (
    <CustomCard title="Site Budget" subHeader={'(All costs are in USD)'}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Pie data={data?.chartData} style={{ height: 350 }} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            columnGap: 2,
            justifyContent: 'center',
            // flexDirection: 'column',
            pt: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              pt: 2,
            }}
          >
            <Typography variant="subtitle1" color="initial">
              Total Budget
            </Typography>
            <Typography variant="h5" color="initial">
              ${totalBudget}
            </Typography>
          </Box>
          <Box
            sx={{
              height: '100%',
              [`& .${dividerClasses.root}`]: {
                mx: 0.5,
              },
            }}
          >
            <Divider orientation="vertical" flexItem />
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              pt: 2,
            }}
          >
            <Typography variant="subtitle1" color="initial">
              Total Expenditure
            </Typography>
            <Typography variant="h5" color="initial">
              ${totalExpenditure}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </CustomCard>
  );
};

export default FinanceSiteBudgetPie;
